import { matchPath } from 'react-router-dom';

import { LESSON_TAB_PATHS } from '@/utils/lesson/lessonTabs';

export const CHAPTER_READER_PATHS = [
  `${LESSON_TAB_PATHS.material}/chapter/:chapterOrder`,
  `${LESSON_TAB_PATHS.material}/chapter/:chapterOrder/subchapter/:subchapterOrder`,
];

export const isChapterReaderPathname = (
  lessonPathname: string,
  pathname: string,
) =>
  CHAPTER_READER_PATHS.some(readerPath =>
    matchPath(`${lessonPathname}/${readerPath}`, pathname),
  );
